import {createAsyncThunk} from "@reduxjs/toolkit";
import {iStateMessage} from "@/customTypes/GenericReduxTypes";
import {iGenericResponse} from "@/customTypes/CommonServiceTypes";
import {curryGetThunkName} from "@/projectUtils/ReduxUtil";
import {httpStatusCodes} from "@/customTypes/NetworkTypes";
import { fbCampaignSetup } from "@/services/api/cresivoxServer";


import { REDUCER_NAME, ifbCampaignDTO} from './Types';
const curriedGetThunkName = curryGetThunkName(REDUCER_NAME);


export const addfbCampaign = createAsyncThunk<
iGenericResponse<any | null> | null,
ifbCampaignDTO,
{
	rejectValue: iStateMessage;
}
>(
curriedGetThunkName("addfbCampaign"),
// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
async (payload, {rejectWithValue}) => {
	try {
		const response = await fbCampaignSetup.createfbCampaign(payload as any);
		if (response) {
			const {httpStatusCode, data, message} = response;
			switch (httpStatusCode) {
				case httpStatusCodes.SUCCESS_OK: {
					if (data && data.data) {
						return {
							data: {
								orders: data.data,
								message,
							}
						};
					} else {
						return rejectWithValue({
							httpStatusCode,
							message,
						});
					}
				}
				default: {
					return rejectWithValue({
						httpStatusCode,
						message,
					});
				}
			}
		} else {
			return rejectWithValue({
				message: "No response received",
			});
		}
	} catch (error) {
		return rejectWithValue({
			message: "Something went wrong",
		});
	}
},
);



export const getfbCampaignList = createAsyncThunk<
  iGenericResponse<any | null> | null,
void,
  {
	  rejectValue: iStateMessage;
  }
>(
  curriedGetThunkName("getfbCampaign"),
  // @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
  async (arg, {rejectWithValue}) => {
	  try {
		  const response = await fbCampaignSetup.getfbCampaign();
		  if (response) {
			  const {httpStatusCode, data, message} = response;

			  switch (httpStatusCode) {
				  case httpStatusCodes.SUCCESS_OK: {
					  if (data && data.data) {
						  return {
							data:{
							  httpStatusCode,
							  data: data.data,
							  message,
							}
						  };
					  } else {
						  return rejectWithValue({
							  httpStatusCode,
							  message,
						  });
					  }
				  }
				  default: {
					  return rejectWithValue({
						  httpStatusCode,
						  message,
					  });
				  }
			  }
		  } else {
			  return rejectWithValue({
				  message: "No response received",
			  });
		  }
	  } catch (error) {
		  return rejectWithValue({
			  message: "Something went wrong",
		  });
	  }
  },
);








